<div class="cvds-unit">
 
  <div *ngIf="unit.coolingSystems?.length">
    <div class="card cv-card__main shadow-sm" *ngFor="let cooling of unit.coolingSystems; let i = index">
      <div class="card-header">Cooling System</div>
      <div class="card-body">
        <cv-cvds-cooling-system
          [cooling]="cooling"
          [index]="i"
        ></cv-cvds-cooling-system>
      </div>
    </div>
  </div>

  <div *ngIf="unit.heatingSystems?.length">
    <div class="card cv-card__main shadow-sm" *ngFor="let heating of unit.heatingSystems; let i = index">
      <div class="card-header">Heating System</div>
      <div class="card-body">
        <cv-cvds-heating-system
          [heating]="heating"
          [index]="i"
        ></cv-cvds-heating-system>
      </div>
    </div>
  </div>

  <div *ngIf="unit.cv_photos?.length">
    <div class="card cv-card__main shadow-sm">
      <div class="card-header">Unit Photos</div>
      <div class="card-body">
        <cv-cvds-photos 
          [photos]="unit.cv_photos">
        </cv-cvds-photos>
      </div>
    </div>
  </div>

  <div class="card cv-card__main shadow-sm" *ngIf="unit.levels.length > 0">
    <div class="card-header">Levels</div>
    <div class="card-body">
      <cv-tab-group>
        <cv-tab [title]="'Level ' + level.levelNumber.Value" *ngFor="let level of unit.levels; let i = index;">
            <div class="padding">
              <cv-cvds-level [level]="level" [index]="i"></cv-cvds-level>
            </div>
        </cv-tab>
      </cv-tab-group>
    </div>
  </div>
</div>